export default function routeGroupSort(routes) {
    // eslint-disable-next-line
    let linegroups = [
        ["A","C","E"],
        ["B","D","F","M"],
        ["G"],
        ["J","Z"],
        ["N","Q","R","W"],
        ["L"],
        ["1","2","3","4","5","6","7"],
        ["SIR"]
    ];

    // for now, just standard sort
    return routes.sort();
}